<!--
 * @Description: 
 * @Author: liXinMan
 * @Date: 2021-12-14 11:28:07
 * @LastEditors: liXinMan
 * @LastEditTime: 2021-12-28 15:22:08
-->
<template>
	<div class="change-lang">
		<img class="btn" :src="require(`../assets/pc-change-images/language-${this.$i18n.locale}.png`)" alt="#" @click="changeLang" />
		<slot />
	</div>
</template>

<script>
export default {
	data() {
		return {}
	},
	methods: {
		changeLang() {
			// 此时为中文，点击切换成俄语
			if (localStorage.getItem('lang') && localStorage.getItem('lang') === 'zh') {
				this.$i18n.locale = 'en'
				localStorage.setItem('lang', this.$i18n.locale)
			} else {
				this.$i18n.locale = 'zh'
				localStorage.setItem('lang', this.$i18n.locale)
			}
		}
	},
	watch: {
		locale(val) {
			this.$i18n.locale = val
			localStorage.setItem('lang', this.$i18n.locale)
		}
	}
}
</script>

<style lang="stylus" scoped>
.change-lang {
  position: absolute;
  right: 0px;
  top: 30px;
  width: 200px;
  cursor: pointer;

  .btn {
    width: 126px;
  }
}

/* 手机 */
@media screen and (max-width: 600px) {
  .change-lang {
    top: 16px !important;
  }
}

/* 平板 */
@media screen and (min-width: 600px) and (max-width: 960px) {
}
</style>
